import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/seminar/202506/mv.png")